module.exports = __webpack_public_path__ + "img/DSC_0074.a1ce04c6.jpg";